<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col cols="12">
                    <div>
                        <p class="font-weight-bold">B. PROGRAM INFORMATION</p>
                    </div>
                    <div>
                        <p>The following information is pulled from the application form you submitted.</p>
                    </div>
                    <b-table-simple responsive striped hover class="text-sm text-md-md">
                        <b-tbody>
                            <b-tr v-for="(item, j) in data" :key="j" class="py-2 py-md-3">
                                <b-td class="font-weight-bold" style="width: 40%;">{{ item.key }}</b-td>
                                <b-td>
                                    <span v-if="item.value2 != null">{{ item.value }} / {{ item.value2 }}</span>
                                    <span v-else>{{ item.value }}</span>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-exchange-b"
                                        v-model="form.status"
                                        name="checkbox-exchange-b"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    />
                                    <div>
                                        I read and confirm that I understand the information in Section B.
                                    </div>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button type="submit" @click="next" variant="primary" class="w-100 w-md-auto">
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            form: {},
            data: []
        }
    },
    created() {
        this.getData()
    },
    computed: {
        ...mapGetters({
            formData: "enrollmentAgreementForm/formData"
        })
    },
    methods: {
        async getData() {
            window.scrollTo(0, 0)
            const d = this.formData
            this.data = [
                {
                    key: 'Program of Study',
                    value: d.program_name ?? 'xxxx',
                },
                {
                    key: 'Program Start Date',
                    value: d.registration_date ?? 'MM/DD/YY',
                },
                {
                    key: 'Registration Type',
                    value: d.registration_type_text ?? 'xxx',
                },
                {
                    key: 'Enrollment Status',
                    value: d.student_status_text ?? 'xxx',
                }
            ]
        },
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$emit('next', 1)
            }
        },
        back() {
            this.$emit('back', -1);
        }
    }
}
</script>
